import React from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../../Components/Modal/modal';
import { LOGOUT_DIALOG, DECLINE_TEXT } from '../../../Constants/strings';
import alertIcon from '../../../Assets/images/svg/alert_icon.svg';
import './logout.scss';

const LogoutDialog = ({
  handleCloseAction,
  selectedItem,
  handleLogoutAction,
  setRows,
  isOpen,
}) => {
  const { TITLES_TEXT, LOGOUT_MESSAGE, BUTTON_ID, LOGOUT_TEXT } = LOGOUT_DIALOG;

  return (
    <FormDialog
      open={isOpen}
      title={TITLES_TEXT}
      PaperProps={{}}
      dialogCss="dialog-message"
      dialogPaperCss="logout-dialog-paper"
      width={260}
      height={205}
      dialogBodycontent={
        <div className="dialog-body-text">
          <div className="dialog-alert-icon">
            <img className="icon-image" src={alertIcon} alt="Alert Icon" />
          </div>
          <div className="dialog-message-text">{LOGOUT_MESSAGE}</div>
        </div>
      }
      button1={DECLINE_TEXT}
      cancelButtonId={`cancel-${BUTTON_ID}`}
      button2={LOGOUT_TEXT}
      submitButtonId={BUTTON_ID}
      button2Action={() => handleLogoutAction(selectedItem, setRows)}
      button1Action={handleCloseAction}
    />
  );
};

LogoutDialog.propTypes = {
  handleCloseAction: PropTypes.func.isRequired,
  handleLogoutAction: PropTypes.func.isRequired,
  selectedItem: PropTypes.object.isRequired,
  setRows: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default LogoutDialog;
